import { get, patch, post, remove } from '@/api/base'

const locationsApi = {
  get: async locationUuid => {
    const response = await get({
      path: `locations/${locationUuid}`,
    })
    return response.success ? response.data.location : null
  },
  getAllForCompany: async companyUuid => {
    const response = await get({
      path: `locations`,
      params: { company_uuid: companyUuid },
    })
    return response.success ? response.data.locations : []
  },
  createDumpingStation: async (locationUuid, dumpingStation) => {
    const response = await post({
      path: `locations/${locationUuid}/dumping_stations`,
      params: dumpingStation,
    })
    return response.success ? response.data.dumping_station : null
  },
  getDumpingStations: async locationUuid => {
    const response = await get({
      path: `locations/${locationUuid}/dumping_stations`,
    })
    return response.success ? response.data.dumping_stations : []
  },
  deleteDumpingStation: async (locationUuid, dumpingStationUuid) => {
    const response = await remove({
      path: `locations/${locationUuid}/dumping_stations/${dumpingStationUuid}`,
    })
    return response.success
  },
  getUsers: async locationUuid => {
    const response = await get({
      path: `locations/${locationUuid}/users`,
    })
    return response.success ? response.data.users : []
  },
  deleteUser: async (locationUuid, userUuid) => {
    const response = await remove({
      path: `locations/${locationUuid}/users/${userUuid}`,
    })
    return response.success
  },
  update: async (locationUuid, params) => {
    const response = await patch({
      path: `locations/${locationUuid}`,
      params,
    })
    return response.success ? response.data.location : null
  },
  create: async params => {
    const response = await post({
      path: `locations`,
      params,
    })
    return response.success ? response.data.location : null
  },
  delete: async locationUuid => {
    const response = await remove({
      path: `locations/${locationUuid}`,
    })
    return response.success
  },
}

export default locationsApi
